import { Alert, Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import AvatarBoCan from '../../AvatarBoCan'
import { AVATAR_BO_PERMISSIONS } from '../../shared/permissions'
import type { AvatarBoClient } from '../../shared/types'
import CatalogueBrowser from './CatalogueBrowser'

export interface AvatarCataloguePanelProps {
  apiBaseUrl: string
  authToken?: string
  client?: AvatarBoClient
}

export default function AvatarCataloguePanel({
  apiBaseUrl,
  authToken,
  client,
}: AvatarCataloguePanelProps) {
  const { formatMessage } = useIntl()

  if (!apiBaseUrl && !client) {
    return (
      <Alert severity="warning">
        {formatMessage(
          { id: 'avatarStudio.notConfigured' },
          { localUrl: 'http://localhost:5001' },
        )}
      </Alert>
    )
  }

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Typography variant="h6" component="h1" sx={{ fontWeight: 600 }}>
          {formatMessage({ id: 'avatarStudio.catalogue.title' })}
        </Typography>
        <AvatarBoCan
          perform={AVATAR_BO_PERMISSIONS.catalogueWrite}
          // tslint:disable-next-line: jsx-no-lambda
          yes={() => (
            <CatalogueBrowser
              apiBaseUrl={apiBaseUrl}
              authToken={authToken}
              client={client}
            />
          )}
          // tslint:disable-next-line: jsx-no-lambda
          no={() => (
            <Alert severity="error">
              {formatMessage(
                { id: 'avatarStudio.noPermission' },
                { permission: AVATAR_BO_PERMISSIONS.catalogueWrite },
              )}
            </Alert>
          )}
        />
      </Stack>
    </Box>
  )
}
